/**
 * Build the order key to usage on query params
 */
function keyBuilder(counter = 0, key = "column") {
  return `order[${counter}][${key}]`;
}

/**
 * Filter builder
 */
export function filterParamsBuilder(options) {
  const { values, searchParams } = options;

  let counter = 0;

  values.forEach((value, index) => {
    if (value) {
      const [columnValue, directionValue] = value.split("-");

      searchParams.append(keyBuilder(counter, "column"), columnValue);

      searchParams.append(keyBuilder(counter, "direction"), directionValue);

      if (index < values.length - 1) {
        counter++;
      }
    }
  });
}

/**
 * Data table builder
 */
export function dataTableParamsBuilder(options) {
  const {
    searchParams,
    pageIndex,
    pageSize,
    keyword,
    filterValues,
    searchKey = "q",
  } = options;

  // searchParams.append("type", "pagination");

  if (pageIndex) {
    searchParams.append("page", String(pageIndex + 1));
  }
  if (pageSize) {
    searchParams.append("pageSize", String(pageSize));
  }

  if (keyword) {
    searchParams.append(searchKey, keyword);
  }

  if (filterValues) {
    filterParamsBuilder({ searchParams, values: filterValues });
  }
}
